module.exports = __webpack_public_path__ + "media/site_templates/www.electriciannearme.agency/images/our_services_3-64f062e8758eaad5e343f379fd017e77.jpg";